<template>
  <div>
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="apiMonitor/logs">
<!--      <div slot="toolbar">-->
<!--        <el-button type="success" @click="refreshCache()">刷新缓存</el-button>-->
<!--      </div>-->
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="来源IP">
            <el-input v-model.trim="filter.sourceIp" placeholder="请输入" clearable/>
          </vm-search>
          <vm-search label="用户名">
            <el-input v-model.trim="filter.userName" placeholder="请输入" clearable/>
          </vm-search>
          <vm-search label="请求路径">
            <el-input v-model.trim="filter.requestPath" placeholder="请输入" clearable/>
          </vm-search>
          <vm-search label="Token状态">
            <el-select v-model.trim="filter.tokenStatus" clearable placeholder="请选择">
              <el-option label="无Token" :value="0"/>
              <el-option label="有效" :value="1"/>
              <el-option label="无效/过期" :value="2"/>
            </el-select>
          </vm-search>
        </div>
      </template>
<!--      <el-table-column type="selection" align="center" width="55" :selectable="isRowSelectable"/>-->
      <el-table-column prop="requestTime" label="请求时间" width="140"/>
      <el-table-column prop="sourceIP" label="来源IP" width="180">
        <template slot-scope="scope">
          <el-link type="danger" @click="optionIp(scope.row,1)">封禁</el-link>
          <el-link type="success" @click="optionIp(scope.row,0)">解封</el-link>
          <span style="margin-left: 5px;">{{scope.row.sourceIP}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="requestPath" label="请求路径"/>
      <el-table-column prop="userName" label="用户名" width="100"/>
      <el-table-column prop="tokenStatus" label="Token状态" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.tokenStatus === 0">无Token</span>
          <span v-if="scope.row.tokenStatus === 1">有效</span>
          <span v-if="scope.row.tokenStatus === 2">无效/过期</span>
        </template>
      </el-table-column>
      <el-table-column prop="statusCode" label="HTTP状态码" width="100"/>
      <el-table-column prop="userAgent" label="User-Agent" show-overflow-tooltip/>
      <el-table-column prop="requestParams" label="请求参数" show-overflow-tooltip/>
      <el-table-column prop="errorMessage" label="错误消息"/>
      <el-table-column prop="module" label="来源模块标识" width="100"/>
    </vm-table>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";
  import auth from "@/util/loginUtil";

  export default {
    name: "AccessLogList",
    components: {VmTable, VmSearch},
    data() {
      return {
        constant,
        authName: auth.getUserName(),
        currentUserId: auth.getUserId(),
        selections: [],
        filter: {
          sourceIp: "",
          userName: "",
          requestPath: "",
          tokenStatus: "",
          errorMessage: "",
        },
      };
    },

    mounted() {
      this.getList(1);
    },

    methods: {
      refreshCache() {
        this.$http.post("basic", "apiMonitor/blacklist/refreshCache").then(() => {
          this.$message.success("刷新成功.");
        });
      },
      optionIp(row, status) {
        if (status === 1) {//封禁IP
          this.$confirm("确定封禁当前IP吗?", "提示", {type: "warning"}).then(() => {
            let params = {
              blockIp: row.sourceIP,
              reason: "web端手动封禁",
            };
            // console.log(params);
            this.$http.post("basic", "apiMonitor/blacklist/block", "", params).then(() => {
              this.$message.success("封禁成功");
            });
          });
        } else {//解封
          this.$confirm("确定解封当前IP吗?", "提示", {type: "warning"}).then(() => {
            let params = {
              blockIp: row.sourceIP,
            };

            this.$http
                .post("basic", "apiMonitor/blacklist/unblockByIp", params, params).then(() => {
              this.$message.success("解封成功");
            });
          });
        }
      },

      getList(pageNo) {
        this.$refs.vmTable.getList(pageNo);
      },
    },
  };
</script>